export const queryKeys = {
    jobsTasks: {
        lists: (criteria?: unknown) => ['jobs-tasks', 'list', criteria],
        counts: (criteria?: unknown) => ['jobs-tasks', 'count', criteria],
    },
    job: {
        detail: (id: string) => ['jobs', 'detail', id],
        result: (jobId: string) => ['jobs', 'result', jobId],
    },
    task: {
        detail: (id: string) => ['tasks', 'detail', id],
        result: (taskId: string) => ['tasks', 'result', taskId],
    },
    environment: {
        lists: () => ['environments'],
    },
    workflowNames: {
        list: (environment: string) => ['workflow-names', 'list', environment],
    },
    projectNames: {
        list: (environment: string) => ['project-names', 'list', environment],
    },
    dataViewer: {
        presignedUrl: (url: string) => ['data-viewer', 'presigned-url', url],
    },
} as const;
